import React from 'react';
import Cookies from 'universal-cookie';
import { useSelector } from 'react-redux';
import { VENDOR_NAME_KEY } from '~/theme/vendorConstants';

import Footer from '~/components/Footer/Footer';
import Header from '~/components/Header/Header';
import NotFound from '~/components/NotFound/NotFound';
import Spinner from '~/components/Spinner/Spinner';
import jwt_decode from 'jwt-decode';
import { RootState } from '~/redux/store';

export const renderPublicComponent = (
  Component: React.ComponentType<any> | React.ComponentType
) => {
  return () => {
    return <Component />;
  };
};

function ProtectedDashboardInner({
  Component
}: {
  Component: React.ComponentType<any>;
}) {
  const cookies = new Cookies();
  // sessionStorage fallback: cookies are blocked in cross-site iframes
  const token = cookies.get('token') || sessionStorage.getItem('token');
  const hasEmbeddedSession = useSelector((state: RootState) =>
    Boolean(state.auth?.user?.uuid && state.auth?.userRole)
  );

  if (!token) {
    sessionStorage.removeItem(VENDOR_NAME_KEY);
    window.location.href = '/login';
    return <></>;
  }
  try {
    const decodedToken: { hasAdminAccess?: boolean } = jwt_decode(token);
    const allowed =
      decodedToken.hasAdminAccess === true || hasEmbeddedSession;
    if (allowed) {
      return (
        <div id='app'>
          <Header />
          <div id='main'>
            <div id='page'>
              <Component />
            </div>
          </div>
          <Footer />
        </div>
      );
    }
    return (
      <div>
        <Header />
        <NotFound />
      </div>
    );
  } catch (error) {
    cookies.remove('token');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem(VENDOR_NAME_KEY);
    window.location.href = '/login';
    return <></>;
  }
}

export const renderProtectedDashboardComponent = (
  Component: React.ComponentType<any> | React.ComponentType
) => {
  return (routeProps?: object) => (
    <ProtectedDashboardInner Component={Component} {...routeProps} />
  );
};

export const renderProtectedRSVPComponent = (
  Component: React.ComponentType<any> | React.ComponentType
) => {
  return () => {
    const cookies = new Cookies();
    const token = cookies.get('token') || sessionStorage.getItem('token');
    return token ? (
      <div id='app'>
        <Header />
        <div id='main'>
          <div id='page'>
            <Component />
          </div>
        </div>
        <Footer />
      </div>
    ) : (
      <div>
        <Header />
        <NotFound />
      </div>
    );
  };
};
